export class ApiResponseError {
  constructor(private response: any) {}

  get Request() {
    return this.response;
  }
}
